
import EDDialog from '../Dialog/EDDialog';
import EDList from '../List/EDList';
import { EDListItemButton } from '../List/Components/EDListItem';
import EDListItemText from '../List/Components/EDListItemText';
import EDTypography from '../Typography/EDTypography';
import { RAPPORTMALL_TYPES } from './RapportMallTypes';

interface IProps {
  open: boolean;
  onClose: (controlType: string) => void;
}

export const RapportMallAddControlDialog: React.FC<IProps> = (
  props: IProps
) => (
  <EDDialog
    open={props.open}
    title="Välj och lägg till en komponent"
    onClose={() => props.onClose('')}
  >
    <EDList>
      {RAPPORTMALL_TYPES.map(control => (
        <EDListItemButton
          key={control.type}
          onClick={() => props.onClose(control.type)}
          dense
        >
          <EDListItemText
            primary={control.title}
            secondary={
              <EDTypography variant="body2" color="text.secondary">
                {control.description}
              </EDTypography>
            }
          />
        </EDListItemButton>
      ))}
    </EDList>
  </EDDialog>
);
